import eventEmitter3 from "eventemitter3";

type RosettaEvents = "showInlineWall";

export const eventEmitter = new eventEmitter3<RosettaEvents>();
